import type {ZudokuConfig} from "zudoku";


const config: ZudokuConfig = {

    redirects: [{from: "/", to: "/getting_started"}],
    site: {
        title: "For Developers",
        logo: {
            src: {light: "/logo-light.png", dark: "/logo-dark.png"},
            alt: "Carto-SI (api)",
            width: "130px",
        },

        footer: {
            // Footer configuration goes here
            position: "start",
            copyright: `© ${new Date().getFullYear()} Carto-SI. All rights reserved.`,
            // Other options...
        },
    },
    page: {
        titleTemplate: "%s", // Retire le suffixe " - Zudoku"
    },
    navigation: [
        {
            type: "category",
            label: "Getting Started",
            items: [
                {
                    type: "category",
                    label: "Introduction",
                    icon: "sparkles",
                    items: [
                        "/getting_started",
                    ],
                },

            ],
        },

        {type: "link", label: "Swagger API", to: "api"},

        {
            type: "category",
            label: "Installation",
            items: [
                {
                    type: "category",
                    label: "Télécharger",
                    icon: "hard-drive-download",
                    collapsed: false,
                    items: [

                        {
                            type: "link",
                            label: "Identification",
                            to: "/installation/identification",
                        },
                        {
                            type: "link",
                            label: "Télécharger tar",
                            to: "/installation/download-tar",
                        },
                        {
                            type: "link",
                            label: "Télécharger Linux",
                            to: "/installation/download-linux",
                        },
                        {
                            type: "link",
                            label: "Télécharger Windows",
                            to: "/installation/download-windows",
                        }
                    ],

                },
                {
                    type: "category",
                    label: "Installation",
                    icon: "activity",
                    collapsed: false,
                    items: [
                        {
                            type: "link",
                            label: "Prérequis",
                            to: "/installation/prerequisites"
                        },
                        {
                            type: "link",
                            label: "Linux (Recommandé)",
                            to: "/installation/install/linux",
                        },
                        {
                            type: "link",
                            label: "Docker",
                            icon: "container",
                            to: "/installation/install/docker/docker",
                        },
                        {
                            type: "link",
                            label: "Windows",
                            to: "/installation/install/windows",
                        },

                    ],
                },
                {
                    type: "category",
                    label: "Configuration",
                    icon: "cog",
                    items: [
                        {
                            type: "link",
                            label: "Fichier de conf Carto-SI",
                            to: "/installation/configuration/config/carto-properties"
                        }, {
                            type: "link",
                            label: "Configurer JVM Windows",
                            to: "/installation/configuration/config/jvm-windows",
                        }, {
                            type: "link",
                            label: "Configurer JVM sous Linux",
                            to: "/installation/configuration/config/jvm-linux",
                        }, {
                            type: "link",
                            label: "Changer le login et le mot de passe du compte admin",
                            to: "/installation/configuration/config/change-admin-account",
                        }, {
                            type: "link",
                            label: "Désactivation du compte Admin du fichier de configuration",
                            to: "/installation/configuration/config/disable-admin-account",
                        }
                    ],
                },
                {
                    type: "category",
                    label: "SAMLV2",
                    icon: "cog",
                    items: [
                        {
                            type: "link",
                            label: "Configuration",
                            to: "/installation/configuration/samlv2/index",
                        },
                        {
                            type: "link",
                            label: "Keycloak",
                            to: "/installation/configuration/samlv2/keycloak",
                        },
                        {
                            type: "link",
                            label: "Azure AD",
                            to: "/installation/configuration/samlv2/azure",
                        },
                    ],
                },
                {
                    type: "category",
                    label: "LDAP",
                    icon: "cog",
                    items: [
                        {
                            type: "link",
                            label: "Configuration LDAP",
                            to: "/installation/configuration/ldap/ldap",
                        },
                    ],
                },
                {
                    type: "category",
                    label: "HTTPS",
                    icon: "cog",
                    items: [
                        {
                            type: "link",
                            label: "Configuration du HTTPS",
                            to: "/installation/configuration/config/https",
                        }, {
                            type: "link",
                            label: "CA non reconnues",
                            to: "/installation/configuration/config/default-keystore",
                        },
                    ],
                },
                {
                    type: "category",
                    label: "Logs",
                    icon: "scroll-text",
                    items: [
                        {
                            type: "link",
                            label: "Récupérer les logs",
                            to: "/installation/logs/get-logs",
                        },
                    ],
                },
                {
                    type: "category",
                    label: "Sauvegarde",
                    icon: "save",
                    items: [
                        {
                            type: "link",
                            label: "Procédure",
                            to: "/installation/sauvegarde",
                        },
                    ],
                },
                {
                    type: "category",
                    label: "Docuementation Technique",
                    icon: "book-open",
                    items: [
                        {
                            type: "link",
                            label: "D.A.T",
                            to: "/installation/dat/dat-linux",
                        },
                    ],
                },
                {
                    type: "category",
                    label: "Migration",
                    icon: "replace",
                    items: [
                        {
                            type: "link",
                            label: "4.6 vers la 4.7",
                            to: "/installation/migration/migration-4.7",
                        },
                        {
                            type: "link",
                            label: "4.5 vers la 4.6",
                            to: "/installation/migration/migration-4.6",
                        },
                        {
                            type: "link",
                            label: "4.5.X vers la 4.5.Y",
                            to: "/installation/migration/migration-4.5-4.5",
                        },
                        {
                            type: "link",
                            label: "4.4 vers la 4.5",
                            to: "/installation/migration/migration-4.5",
                        },
                        {
                            type: "link",
                            label: "4.4.14 vers la 4.4.15",
                            to: "/installation/migration/migration-4.4.15",
                        },
                        {
                            type: "link",
                            label: "4.3 vers la 4.4",
                            to: "/installation/migration/migration-4.4",
                        },
                        {
                            type: "link",
                            label: "4.2 vers la 4.3",
                            to: "/installation/migration/migration-4.3",
                        },
                        {
                            type: "link",
                            label: "4.1 vers la 4.2",
                            to: "/installation/migration/migration-4.2",
                        },
                        {
                            type: "link",
                            label: "Migration vers la 4.1",
                            to: "/installation/migration/migration-4.1",
                        },
                    ],

                },
            ],
        },

        {
            type: "category",
            label: "Script",
            items: [
                {
                    type: "category",
                    label: "Introduction",
                    icon: "sparkles",
                    collapsed: false,
                    items: [
                        {
                            type: "link",
                            label: "Bien démarrer",
                            to: "/script/intro/intro/intro",
                        },
                        {
                            type: "link",
                            label: "Token d’accès à Carto-SI",
                            to: "/script/intro/token/token",
                        },
                        {
                            type: "link",
                            label: "Définir le format des données",
                            to: "/script/intro/mimetype/mimetype",
                        },
                        {
                            type: "link",
                            label: "Lire et modifier les données",
                            to: "/script/intro/using_api/using_api",
                        },
                        {
                            type: "link",
                            label: "Champs personnalisés",
                            to: "/script/intro/custom_field/custom_field",
                        },
                    ],
                },
                {
                    type: "category",
                    label: "Les filtres",
                    icon: "list-filter-plus",
                    items: [
                        {
                            type: "link",
                            label: "Opérations de filtrage",
                            to: "/script/filter/filters-ref",
                        }, {
                            type: "link",
                            label: "Exemples de Filtres",
                            to: "/script/filter/filters-example",
                        },

                    ],
                },
                {
                    type: "category",
                    label: "Les Références",
                    icon: "library",
                    items: [
                        {
                            type: "link",
                            label: "Liste des types de fiches",
                            to: "/script/references/object_type",
                        }, {
                            type: "link",
                            label: "Liste des types de champs",
                            to: "/script/references/type",
                        }, {

                            type: "link",
                            label: "Version des fiches",
                            to: "/script/references/card_version",
                        },
                    ],
                },
                {
                    type: "category",
                    label: "Examples de script",
                    icon: "app-window-mac",
                    items: [
                        {
                            type: "link",
                            label: "Mise à jour des comptes utilisateurs à partir d'un fichier CSV",
                            to: "/script/v3/push_accounts/push_accounts",
                        },
                        {
                            type: "link",
                            label: "Gestion des teamleaders",
                            to: "/script/v2/teamleader/teamleader",
                            badge: {
                                "label": "Deprecated",
                                "color": "red"
                            }
                        },
                        {
                            type: "link",
                            label: "Accès aux API de livraison",
                            to: "/script/v2/delivery/delivery",
                            badge: {
                                "label": "Deprecated",
                                "color": "red"
                            }
                        },
                        {
                            type: "link",
                            label: "Comment changer automatiquement les e-mails des utilisateurs",
                            to: "/script/v2/example/email-change/email-change",
                            badge: {
                                "label": "Deprecated",
                                "color": "red"
                            }
                        },
                    ],
                },
            ],
        }, {
            type: "category",
            label: "Sécurité",
            items: [
                {
                    type: "category",
                    label: "Communication",
                    icon: "phone-incoming",
                    collapsed: false,
                    items: [
                        {
                            type: "link",
                            label: "Alertes de sécurité",
                            to: "/security/com/mailing-alert-security",
                        }
                    ],
                },
                {
                    type: "category",
                    label: "Notifications de sécurité",
                    icon: "bell",
                    collapsed: false,

                    items: [
                        {
                            type: "link",
                            label: "Version 1.0 --> 4.5.46",
                            to: "/security/notification/2024/guest-xss",
                        },
                        {
                            type: "link",
                            label: "Version 1.0 --> 4.5.41",
                            to: "/security/notification/2024/cve-commons-compress",
                        },
                        {
                            type: "link",
                            label: "Version 1.0 --> 4.3.32",
                            to: "/security/notification/2022/mail-tls1",
                        },
                        {
                            type: "link",
                            label: "Version 1.0 --> 4.3.22",
                            to: "/security/notification/2022/new-password",
                        },
                        {
                            type: "link",
                            label: "Version 1.0 --> 4.3.14",
                            to: "/security/notification/2022/prepare-statement",
                        },
                        {
                            type: "link",
                            label: "Version 1.0 --> 4.3.14",
                            to: "/security/notification/2022/backup-tenant",
                        },
                        {
                            type: "link",
                            label: "Version 4.2.1 --> 4.3.13",
                            to: "/security/notification/2022/saml-sha1",
                        },
                        {
                            type: "link",
                            label: "Version 4.2.1 --> 4.3.7",
                            to: "/security/notification/2022/cve-commons-configuration",
                        },
                        {
                            type: "link",
                            label: "Version 1.0 --> 4.2.13",
                            to: "/security/notification/2022/conf-leak-resteasy",
                        }, {
                            type: "link",
                            label: "Version 1.0 --> 4.2.12",
                            to: "/security/notification/2022/xss-1",
                        },
                        {
                            type: "link",
                            label: "Version 1.0 --> 4.2",
                            to: "/security/notification/2022/saml",
                        },
                        {
                            type: "link",
                            label: "Version 1.0 --> 4.2",
                            to: "/security/notification/2022/hashed-admin-password",
                        },
                    ],
                }
            ]
        }
    ],
    apis: {
        type: "file",
        badge: {
            "label": "Beta",
            "color": "yellow"
        },
        input: "./openapi.json",
        path: "api",
    },
    search: {
        type: "pagefind",
    },
};

export default config;
